import { postForm } from '@/shared/api/client';
import { submitForm } from '@/shared/api/submit';

export interface EarnBonusParams {
  file: File;
  amount: string;
  comment: string;
  burned: boolean;
  onlyCustomer: boolean;
}

export function earnBonusByPhone({ file, amount, comment, burned, onlyCustomer }: EarnBonusParams) {
  return submitForm('/uploads/bonus/earn-bonus-by-phone/', {
    file,
    amount,
    description: comment,
    bonus_is_burn: burned,
    only_customer: onlyCustomer,
  });
}

export function fetchEarnBonusReport() {
  return postForm<Blob>('/uploads/bonus/get-report-earn-bonus/', {}, { responseType: 'blob' });
}
